import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';
import { apiQueryOptions, BaseApiQueryOptions } from './apiQueryOptions';

export const TierApi = {
    getAvailable: (options?: BaseApiQueryOptions) => apiQueryOptions(['tier', 'getAvailable'], (api) => api.tier.getAvailable(), options),
    get: (tierId: string, options?: BaseApiQueryOptions) => apiQueryOptions(['tier', 'get', tierId], (api) => api.tier.get(tierId), options),
    isAvailable: (options?: BaseApiMutationOptions<ApiClient['tier']['isAvailable']>) => apiMutationOptions((api) => api.tier.isAvailable, options)
};
